export enum SubmitType {
  CONFIRM = 'CONFIRM',
  ADD = 'ADD',
  TRANSFER = 'TRANSFER',
  CERTIFY = 'CERTIFY',
  VALIDATE = 'VALIDATE',
  CREATE = 'CREATE',
  START = 'START',
  TERMINATE = 'TERMINATE',
  SYNC = 'SYNC'
}
